<template>
  <div v-if="dpes">
    <h1 style="margin: 0 0 4px">DPE Contact Info</h1>
    <div class="d-flex justify-content-between align-items-start mb-2">
      <hilo-button
        label="Add +"
        @click="navigateToAddDpe"
        style="margin-bottom: 10px"
      />
      <input
        class="search-input"
        v-model="search"
        placeholder="Search"
        @input="filterDPEs"
      />
    </div>
    <hilo-table :columns="columns" :data="filteredDpes" />
    <NotesModal
      v-if="showNotesModal && selectedRow && selectedRow.id"
      :isVisible="showNotesModal"
      :targetUserId="selectedRow?.user?.id"
      :targetName="`${selectedRow?.firstName} ${selectedRow?.lastName}`"
      noteTypeName="DPE Contact Info"
      @close="closeNotesModal"
    />
  </div>
</template>

<script>
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import HiloButton from "src/components/HiloComponents/HiloButton.vue";

import DpeAPIService from "src/servicehandlers/DpeAPIService";
import NotesModal from "@/components/HiloComponents/NotesModalOld.vue";
const dpeAPIService = new DpeAPIService();

export default {
  name: "DPEs",
  components: {
    NotesModal,
    HiloButton,
    HiloTable,
  },
  data() {
    return {
      dpes: [],
      filteredDpes: [],
      search: "",
      showNotesModal: false,
      selectedRow: {},
      columns: [
        {
          key: "id",
          component: "HiloButton",
          backgroundColor: "#a8d5a2",
          componentProps: (row) => ({
            styleType: "editIcon",
            onClick: () => this.navigateToEditDpe(row.id),
          }),
        },
        { key: "dpePreferred", label: "Preferred", backgroundColor: "#a8d5a2" },
        { key: "firstName", label: "First", backgroundColor: "#a8d0e6" },
        { key: "lastName", label: "Last", backgroundColor: "#a8d0e6" },
        {
          key: "dpePreferredMethod",
          label: "Preferred Method",
          backgroundColor: "#a8d0e6",
        },
        { key: "phone", label: "Phone", backgroundColor: "#a8d0e6" },
        { key: "email", label: "Email", backgroundColor: "#a8d0e6" },
        { key: "homeBase", label: "Home Base", backgroundColor: "#f8c8c8" },
        { key: "travel", label: "Travel", backgroundColor: "#f8c8c8" },
        { key: "ppl", label: "PPL", backgroundColor: "#cbbde2" },
        { key: "ir", label: "Instrument", backgroundColor: "#cbbde2" },
        { key: "com", label: "Commercial", backgroundColor: "#cbbde2" },
        {
          key: "cfiInitial",
          label: "CFI - Initial",
          backgroundColor: "#cbbde2",
        },
        { key: "cfii", label: "CFII", backgroundColor: "#cbbde2" },
        { key: "comMulti", label: "Com Multi", backgroundColor: "#cbbde2" },
        { key: "mei", label: "MEI", backgroundColor: "#cbbde2" },
        { key: "weight", label: "Weight", backgroundColor: "#f9e79f" },
        {
          key: "other",
          label: "Notes",
          component: "HiloButton",
          backgroundColor: "#f9e79f",
          componentProps: (row) => ({
            label: "View",
            onClick: () => this.openNotesModal(row),
          }),
        },
      ],
    };
  },
  async mounted() {
    await this.getDpes();
  },
  methods: {
    async getDpes() {
      return dpeAPIService
        .get(this.$router)
        .then((response) => {
          this.dpes = response;
          for (let dpe of this.dpes) {
            dpe.firstName = dpe.user?.firstName;
            dpe.lastName = dpe.user?.lastName;
            dpe.dpePreferred = dpe.dpePreferred?.name || "-";
            dpe.dpePreferredMethod = dpe.dpePreferredMethod?.name || "-";
            dpe.phone = dpe.user?.phone || "-";
            dpe.email = dpe.user?.email || "-";
            dpe.homeBase = dpe.homeBase || "-";
            dpe.travel = dpe.dpeTravel?.name || "-";
            dpe.ppl = this.formatRate(dpe.ppl);
            dpe.ir = this.formatRate(dpe.ir);
            dpe.com = this.formatRate(dpe.com);
            dpe.cfiInitial = this.formatRate(dpe.cfiInitial);
            dpe.cfii = this.formatRate(dpe.cfii);
            dpe.comMulti = this.formatRate(dpe.comMulti);
            dpe.mei = this.formatRate(dpe.mei);
            dpe.weight = dpe.weight || "-";
          }
          this.filteredDpes = this.dpes;
        })
        .catch((error) => {});
    },
    filterDPEs() {
      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns
        .map((column) => column.key)
        .filter((key) => key !== "id");
      this.filteredDpes = this.dpes.filter((dpe) => {
        return columnKeys.some((key) => {
          const value = dpe[key];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
    },
    formatRate(rate) {
      if (rate === null) {
        return "-";
      } else if (rate === 0) {
        return "DNE";
      } else if (rate === 1) {
        return "Yes";
      } else {
        return parseFloat(rate).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
    },
    navigateToAddDpe() {
      this.$router.push({ name: "Add Edit DPE" });
    },
    navigateToEditDpe(id) {
      this.$router.push({ name: "Add Edit DPE", params: { id } });
    },
    openNotesModal(row) {
      this.selectedRow = row;
      this.showNotesModal = true;
    },
    closeNotesModal() {
      this.showNotesModal = false;
      this.selectedRow = {};
    },
  },
};
</script>

<style scoped></style>
